/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class WindowInsetCombinationDeclarationDto {
    sort: number;
    copiedFromId: string;
    flex: number | null;
    fixedWidth: number | null;
}
